import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const PageHeader = styled.section`
  height: 320px;
  background: linear-gradient(rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75)), url("/images/wholesale-hero.webp");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  color: white;

  .tagline {
    font-size: 1.2rem;
    color: #ff6600;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin-bottom: 0.5rem;
  }

  h1 {
    font-size: 2.5rem;
    width: 100%;
    text-align: center;
  }
`;

const Content = styled.section`
  padding: 60px 0;
  background: #0a0a0a;
  .container {
    max-width: 1100px;
    margin: 0 auto;
    padding: 0 1rem;
  }
  h2 {
    color: #ff6600;
  }
  .benefits {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 1.5rem;
    margin-top: 2rem;
  }
  .card {
    background: #1a1a1a;
    border-radius: 8px;
    padding: 1.25rem;
    border: 1px solid #333;
    transition: all 0.3s ease;
    &:hover {
      border-color: #ff6600;
      box-shadow: 0 6px 20px rgba(255, 102, 0, 0.2);
    }
    h3 {
      color: #ff6600;
    }
    p {
      color: #b0b0b0;
    }
  }
  .cta {
    margin-top: 2rem;
    text-align: center;
    p {
      color: #e0e0e0;
    }
  }
`;

const Wholesale = () => {
  return (
    <>
      <PageHeader>
        <div className="container">
          <div className="tagline">Built for the long haul</div>
          <h1>Wholesale Tyres — Supply & Fleet Solutions</h1>
        </div>
      </PageHeader>

      <Content>
        <div className="container">
          <h2>Why buy wholesale from Roadwise tyres?</h2>
          <div className="benefits">
            <div className="card">
              <h3>Competitive Pricing</h3>
              <p>Bulk discounts, fleet pricing and volume deals tailored to your business.</p>
            </div>
            <div className="card">
              <h3>Wide Brand Range</h3>
              <p>Access to Landlux and many major tyre brands with assured supply chain support.</p>
            </div>
            <div className="card">
              <h3>Fast Logistics</h3>
              <p>Priority dispatch, nationwide shipping and dedicated account support.</p>
            </div>
            <div className="card">
              <h3>Technical Support</h3>
              <p>Advice on tyre selection, load ratings and fuel efficiency for your fleet.</p>
            </div>
          </div>

          <div className="cta">
            <p style={{ fontSize: "1.1rem" }}>Ready to discuss wholesale pricing and terms?</p>
            <Link
              to="/get-quote"
              className="btn"
              style={{ background: "#ff6600", color: "white", padding: "12px 22px", borderRadius: 6, textDecoration: "none" }}>
              Request Wholesale Quote
            </Link>
            <p style={{ marginTop: 12 }}>
              Or call us at <strong>0481 313 403</strong>
            </p>
          </div>

          <section style={{ marginTop: 40 }}>
            <h2>Tyre Sizes & Description</h2>
            <div style={{ marginTop: 12 }}>
              <table style={{ width: "100%", borderCollapse: "collapse", color: "#e0e0e0" }}>
                <tbody>
                  <tr style={{ borderBottom: "1px solid #333" }}>
                    <td style={{ padding: "12px 8px" }}>295</td>
                    <td style={{ padding: "12px 8px" }}>(Steer)</td>
                  </tr>
                  <tr style={{ borderBottom: "1px solid #333" }}>
                    <td style={{ padding: "12px 8px" }}>385</td>
                    <td style={{ padding: "12px 8px" }}>(Steer)</td>
                  </tr>
                  <tr style={{ borderBottom: "1px solid #333" }}>
                    <td style={{ padding: "12px 8px" }}>11R</td>
                    <td style={{ padding: "12px 8px" }}>(Drive Tyre)</td>
                  </tr>
                  <tr style={{ borderBottom: "1px solid #333" }}>
                    <td style={{ padding: "12px 8px" }}>11R</td>
                    <td style={{ padding: "12px 8px" }}>(All Position)</td>
                  </tr>
                  <tr style={{ borderBottom: "1px solid #333" }}>
                    <td style={{ padding: "12px 8px" }}>11R</td>
                    <td style={{ padding: "12px 8px" }}>(Trailer Tyre)</td>
                  </tr>
                  <tr>
                    <td style={{ padding: "12px 8px" }}>275/70 R22.5</td>
                    <td style={{ padding: "12px 8px" }}></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </Content>
    </>
  );
};

export default Wholesale;
